/**
 * The single entry point for user-facing notifications. Components never call the
 * toast library directly — they push a message through `notify`, which owns the
 * variants/conventions and keeps the renderer (sonner today) behind one seam. The
 * mounted <Toaster/> (see the app providers) is the centralised queue and manages
 * lifecycle — dismissal, stacking, animation — so callers never do that themselves.
 *
 * When the persistent Notifications feature (in-app inbox) lands, this façade is the
 * one place to also route selected notifications to it — callers don't change.
 */
import { toast } from 'sonner';

export interface NotifyOptions {
  /** Secondary line rendered under the message. */
  description?: string;
}

export const notify = {
  success: (message: string, options?: NotifyOptions) => toast.success(message, options),
  error: (message: string, options?: NotifyOptions) => toast.error(message, options),
  info: (message: string, options?: NotifyOptions) => toast(message, options),
};
